import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button";

export default function GetInfo() {
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js-na2.hsforms.net/forms/embed/243337971.js";
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white text-black flex flex-col justify-center items-center pb-10 pt-10 px-4">
      {/* Sign Up Now Option */}
      <div className="w-full max-w-xl mb-8 text-center">
        <p className="text-lg text-gray-700 mb-4">
          Ready to get started?
        </p>
        <Button 
          className="bg-[#9B1421] hover:bg-[#7A0F1A] text-white px-8 py-3 font-semibold"
          onClick={() => navigate("/signup")}
        >
          Sign Up Now
        </Button>
        <p className="text-sm text-gray-500 mt-4">
          Or fill out the form below to learn more
        </p>
      </div>

      {/* Contact Form */}
      <div className="w-full max-w-xl">
        <div
          className="hs-form-frame w-full"
          data-region="na2"
          data-form-id="33cb1714-7faf-45c6-8fa1-e866e46eb8c5"
          data-portal-id="243337971"
        />
      </div>
    </div>
  );
}
